var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9004 11.85C13.9004 12.8165 13.1169 13.6 12.1504 13.6C11.1839 13.6 10.4004 12.8165 10.4004 11.85C10.4004 10.8835 11.1839 10.1 12.1504 10.1C13.1169 10.1 13.9004 10.8835 13.9004 11.85Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10C1.25 8.48122 2.48122 7.25 4 7.25H14C15.5188 7.25 16.75 8.48122 16.75 10V20C16.75 21.5188 15.5188 22.75 14 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V10ZM4 8.75C3.30964 8.75 2.75 9.30964 2.75 10V16.7004L6.0188 13.4316C6.30606 13.1444 6.7767 13.1611 7.04276 13.4681L10.6129 17.5875L12.0054 16.195C12.2788 15.9216 12.722 15.9216 12.9954 16.195L15.25 18.4496V10C15.25 9.30964 14.6904 8.75 14 8.75H4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C8.48122 1.25 7.25 2.48122 7.25 4V5.75H8.75V4C8.75 3.30964 9.30964 2.75 10 2.75H20C20.6904 2.75 21.25 3.30964 21.25 4V12.4496L18.9954 10.195C18.7938 9.99348 18.5 9.94052 18.25 10.0361V16.75H20C21.5188 16.75 22.75 15.5188 22.75 14V4C22.75 2.48122 21.5188 1.25 20 1.25H10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3782 7.42084C17.6111 7.53554 17.8732 7.59998 18.1504 7.59998C19.1169 7.59998 19.9004 6.81647 19.9004 5.84998C19.9004 4.88348 19.1169 4.09998 18.1504 4.09998C17.1839 4.09998 16.4004 4.88348 16.4004 5.84998C16.4004 6.12708 16.4648 6.38915 16.5795 6.62202C16.8798 6.85169 17.1486 7.1205 17.3782 7.42084Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.f3674849c5ef917759c4eef87d746e78.svg";
export { ForwardRef as ReactComponent };